const mockReports = [
	{
		name: "Exovera Migration Report 1-14 July.docx",
		date: 1563105600,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/CBP-NT+Report_1-14+July+2019.docx",
	},
	{
		name: "Exovera Migration Report 15-21 July.docx",
		date: 1563710400,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/CBP-NT+Report_15-21+July+2019.docx",
	},
	{
		name: "Exovera Migration Report 17-30 June.docx",
		date: 1561896000,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/CBP-NT+Report_17-30+June+2019.docx",
	},
	{
		name: "Exovera Migration Report 12-18 Aug.docx",
		date: 1566302400,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/CBP-NT+Report_Aug_20.docx",
	},
	{
		name: "Exovera Migration Report 22-28 July.docx",
		date: 1564315200,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/Exovera+Migration+Report_22-28+July+2019.docx",
	},
	{
		name: "Exovera Migration Report 5-11 Aug.docx",
		date: 1565524800,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/Exovera+NT+Migration+Report_5-11+Aug+2019.docx",
	},
	{
		name: "Exovera Migration Report 29-July-4-Aug.docx",
		date: 1564920000,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/Exovera+Weekly+NT+Report5_29July-Aug4_2019.docx",
	},
	{
		name: "Exovera Migration Report 19-25 Aug.docx",
		date: 1566907200,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/CBP-NT+Report_Aug_27.docx",
	},
	{
		name: "Exovera Migration Report 26-Aug-1-Sep.docx",
		date: 1567512000,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/Exovera+Migration+Report+26-Aug-1-Sep.docx",
	},
	{
		name: "Exovera Migration Report 2-8 Sep.docx",
		date: 1568116800,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/CBP-NT+Report_Sept_10.docx",
	},
	{
		name: "Exovera Migration Report 9-15 Sep.docx",
		date: 1568721600,
		hrefUrl: "https://cbp-reports.s3.amazonaws.com/EXOVERA_CBP-NT+Report_Sept_18.docx",
	},
];

export default mockReports;
